import { ModalNext } from "@ui-kit/Modal/ModalNext";
import { Text } from "@ui-kit/Text/Text";
import { Button } from "@ui-kit/Button/Button";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import "./ConfirmationModal.css";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  cancelLabel,
  confirmLabel,
}) => {
  const { t } = useTranslation();

  return (
    <ModalNext isOpen={isOpen} onClose={onClose} width={384}>
      <div className="confirmation-modal-component">
        <Text variant="fontHeadingMedium">{title}</Text>
        <Text variant="fontBodyLarge">{message}</Text>
        <div className="actions-buttons">
          <Button type="outlinePrimary" onPress={onClose} fullWidth>
            {cancelLabel ?? t("common.cancel")}
          </Button>
          <Button type="primary" onPress={onConfirm} fullWidth>
            {confirmLabel ?? t("common.delete")}
          </Button>
        </div>
      </div>
    </ModalNext>
  );
};

export { ConfirmationModal };
